import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const UpgradeNote = ({ feature, testId }) => (
  <div className="flex items-center gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200 text-sm" data-testid={testId}>
    <Lock className="w-4 h-4 text-amber-600 flex-shrink-0" />
    <p className="text-amber-800 flex-1">{feature} is available on the Growth and Premium plans.</p>
    <Link to="/seller/plans" className="font-semibold text-primary-600 hover:underline" data-testid={`${testId}-link`}>
      Upgrade
    </Link>
  </div>
);
